// Spain
export const locale = {
}
